// public
import React from 'react';
import PropTypes from 'prop-types';

import { mergeStyles } from '@xingternal/merge-styles';

import base from './BadgeShell.css';

const Badge = ({ children, skin }) => {
  const styles = mergeStyles(base, skin);
  return <span className={styles.badge}>{children}</span>;
};

Badge.propTypes = {
  /**  label of the badge should always be a number */
  children: PropTypes.number,
  /** add your custom class name skin={{badge: style.heroClass}}  */
  skin: PropTypes.object,
};

export default Badge;
